// Chefi speaks in icons: words next to icons only show with the "Show labels" accessibility
// setting, or while a screen reader runs. Hidden words stay as accessibility labels.
import { useEffect } from 'react';
import { AccessibilityInfo, Platform } from 'react-native';
import { create } from 'zustand';
import { useSettings } from './store/settings';

const useScreenReader = create<{ on: boolean; started: boolean }>(() => ({ on: false, started: false }));

function watchScreenReader() {
  // A browser cannot tell (React Native Web always answers yes): there only the setting counts.
  if (Platform.OS === 'web' || useScreenReader.getState().started) return;
  useScreenReader.setState({ started: true });
  AccessibilityInfo.isScreenReaderEnabled().then(on => useScreenReader.setState({ on })).catch(() => {});
  AccessibilityInfo.addEventListener('screenReaderChanged', on => useScreenReader.setState({ on }));
}

/** True when words should show next to icons. */
export function useLabels(): boolean {
  const show = useSettings(s => s.showLabels);
  const reader = useScreenReader(s => s.on);
  useEffect(watchScreenReader, []);
  return show || reader;
}
